<template>
	<div style="padding: 20px;">
		<el-row :gutter="20">
			<el-col :span="12" style="margin-bottom: 10px;">
				<div class="centext-box" style="margin-bottom: 20px;">
					<div class="header">
						基本信息
					</div>
					<div style="padding: 20px;" class="form">
						<div v-for="(item,index) in base_info_list" :key="index"
							style="display: flex;align-items: center;padding: 12px;justify-content: space-between;border-bottom: 1px solid #686868;font-size: 14px;">
							<span>{{item.title}}</span>
							<span v-if="item.show_value || item.show_value ===0">{{item.show_value}}</span>
							<el-link v-else type="primary" icon="el-icon-edit" @click="copy(item.copy_value)">复制
							</el-link>
						</div>
					</div>
				</div>
				<div class="centext-box" style="margin-bottom: 20px;">
					<div class="header">
						售卡设置
					</div>
					<div style="padding: 10px;">
						<div class="t-header">
							<div class="t-item">
								卡密类型
							</div>
							<div class="t-item">
								是否出售
							</div>
							<div class="t-item">
								价格
							</div>
						</div>
						<div class="t-body" v-for="(item,index) in software_info.card_type_conf"
							v-if="[8,10].indexOf(parseInt(index))==-1" :key="index">
							<div class="t-item">
								{{item.name}}卡
							</div>
							<div class="t-item">
								<el-switch :value ="salesquence.indexOf(parseInt(index))!=-1 ? true : false" @change="switchChange($event,index)">
								</el-switch>
							</div>
							<div class="t-item">
								<el-input type="number" placeholder="请输入" size="small"
									v-model="price[index]" style="width: 70px;"></el-input>
							</div>
						</div>
						<div style="padding: 20px;display: flex;justify-content: flex-end;">
							<el-button type="primary" size="small" @click="submit('card_sell')">修改</el-button>
						</div>
					</div>
				</div>
				<div class="centext-box" style="margin-top: 10px;">
					<div class="header">
						免费卡设置
					</div>
					<div style="padding: 20px 20px 10px 20px;" class="form">
						<el-form :model="software_info" :rules="software_rules" ref="free_card" label-width="220px"
							class="demo-ruleForm" label-position="left">
							<el-form-item label="每天下发的免费卡数量" prop="free_card_num">
								<el-input type="number" placeholder="请输入每天下发的免费卡数量" size="small"
									v-model="software_info.free_card_num" style="width: 300px;"></el-input>
							</el-form-item>
							<el-form-item label="看几次广告可以获取免费卡" prop="free_card_need_adtimes">
								<el-input type="number" placeholder="请输入看几次广告可以获取免费卡" size="small"
									v-model="software_info.free_card_need_adtimes" style="width: 300px;"></el-input>
							</el-form-item>
							<el-form-item label="免费卡的可用时长" prop="free_card_timelong">
								<Picker :date="software_info.free_card_timelong" placeholder="请选择自定义时间" @confrim="confrimDate($event,'free_card_timelong')"></Picker>
							</el-form-item>
							<el-form-item label="是否显示代理相关">
								<el-radio-group v-model="software_info.is_display_page">
									<el-radio :label="0">不显示</el-radio>
									<el-radio :label="1">显示</el-radio>
								</el-radio-group>
							</el-form-item>
							<el-form-item style="padding: 10px 10px 0px 10px;display: flex;justify-content: flex-end;margin-top: -20px;">
								<el-button type="primary" size="small" @click="submitForm('free_card')">修改</el-button>
							</el-form-item>
						</el-form>
					</div>
				</div>
			</el-col>
			<el-col :span="12" style="margin-bottom: 20px;">
				<el-form :model="software_info" :rules="software_rules" ref="softwareForm" label-width="200px"
					class="demo-ruleForm" label-position="left" style="border-radius: 5px;background-color: rgb(66, 75, 79);">
					<div class="centext-box" style="border-bottom-left-radius: 0px;border-bottom-right-radius: 0px;">
						<div class="header">
							基础设置
						</div>
						<div style="padding: 20px 20px 0px 20px;" class="form">
							
								
								<el-form-item label="允许多端同时在线数量" prop="onlinenum">
									<el-input type="number" placeholder="请输入允许多端同时在线数量" size="small"
										v-model="software_info.onlinenum" style="width: 300px;"></el-input>
								</el-form-item>
								<el-form-item label="卡密长度" prop="card_length">
									<el-input type="number" placeholder="请输入卡密长度" size="small"
										v-model="software_info.card_length" style="width: 300px;"></el-input>
								</el-form-item>
								
								<el-form-item label="心跳时间" prop="heart_beat_time">
									<div slot="label" style="display: flex;align-items: center;">
										<span>心跳时间</span>
										<img src="../../assets/question.png" style="width: 20px;height: 20px;margin-left: 5px;cursor: pointer;" @click="openMsg(0)">
									</div>
									<Picker :date="software_info.heart_beat_time" type="h" placeholder="请选择心跳时间" @confrim="confrimDate($event,'heart_beat_time')"></Picker>
								</el-form-item>
								<el-form-item label="中文名(备注)">
									<el-input type="text" placeholder="请输入中文名" size="small" v-model="software_info.one"
										style="width: 300px;"></el-input>
								</el-form-item>
								<el-form-item label="软件前台开关">
									<div slot="label" style="display: flex;align-items: center;">
										<span>软件前台开关</span>
										<img src="../../assets/question.png" style="width: 20px;height: 20px;margin-left: 5px;cursor: pointer;" @click="openMsg(12)">
									</div>
									<el-switch v-model="software_info.switch" :active-value="1" :inactive-value="0">
									</el-switch>
								</el-form-item>

						</div>
					</div>
					<div class="centext-box" style="border-top-left-radius: 0px;border-top-right-radius: 0px;border-top: 1px solid #585858;">
						<div class="header" style="display: flex;align-items: center;justify-content: space-between;cursor: pointer;" @click="showSuper=!showSuper">
							高级设置 -（点击后展示更多设置）
							<i class="el-icon-caret-top" v-if="showSuper"></i>
							<i class="el-icon-caret-bottom" v-else></i>
						</div>
						<div style="padding: 20px 20px 0 20px;" class="form" v-show="showSuper">
								
								
								<el-form-item label="自定义时间" prop="defind_card_time">
									<div slot="label" style="display: flex;align-items: center;">
										<span>自定义卡时间</span>
										<img src="../../assets/question.png" style="width: 20px;height: 20px;margin-left: 5px;cursor: pointer;" @click="openMsg(1)">
									</div>
									<Picker :date="software_info.defind_card_time" placeholder="请选择自定义时间" @confrim="confrimDate($event,'defind_card_time')"></Picker>
									
								</el-form-item>
								
								<el-form-item label="试用卡时间" prop="test_card_time">
									<div slot="label" style="display: flex;align-items: center;">
										<span>试用卡时间</span>
										<img src="../../assets/question.png" style="width: 20px;height: 20px;margin-left: 5px;cursor: pointer;" @click="openMsg(2)">
									</div>
									<Picker :date="software_info.test_card_time" placeholder="请选择试用卡时间" @confrim="confrimDate($event,'test_card_time')"></Picker>
								</el-form-item>
								<el-form-item label="每个微信试用时间间隔" prop="try_use_freeze">
									<div slot="label" style="display: flex;align-items: center;">
										<span>每个微信试用时间间隔</span>
										<img src="../../assets/question.png" style="width: 20px;height: 20px;margin-left: 5px;cursor: pointer;" @click="openMsg(3)">
									</div>
									<Picker :date="software_info.try_use_freeze" placeholder="请选择每个微信试用时间间隔" @confrim="confrimDate($event,'try_use_freeze')"></Picker>
									<!-- <el-input type="number" placeholder="请输入每个微信试用时间间隔" size="small"
										v-model="" style="width: 300px;"></el-input> -->
								</el-form-item>
								<el-form-item label="下载地址">
									<el-input type="text" placeholder="请输入下载地址" size="small" v-model="software_info.path"
										style="width: 300px;"></el-input>
								</el-form-item>
								
								<el-form-item label="版本">
									<el-input type="text" placeholder="请输入版本号" size="small" v-model="software_info.version"
										style="width: 300px;"></el-input>
								</el-form-item>
								<el-form-item label="自定义卡对外展示名称">
									<el-input type="text" placeholder="请输入自定义卡对外展示名称" size="small"
										v-model="software_info.cardname" style="width: 300px;"></el-input>
								</el-form-item>
								<el-form-item label="软件公告">
									<div slot="label" style="display: flex;align-items: center;">
										<span>软件公告</span>
										<img src="../../assets/question.png" style="width: 20px;height: 20px;margin-left: 5px;cursor: pointer;" @click="openMsg(5)">
									</div>
									<el-input
									  type="textarea"
									  :autosize="{ minRows: 4, maxRows: 10}"
									  placeholder="请输入软件公告"
									  style="width: 300px;"
									  v-model="software_info.description"
									  >
									</el-input>
								</el-form-item>
								<el-form-item label="默认配置">
									<div slot="label" style="display: flex;align-items: center;">
										<span>默认配置</span>
										<img src="../../assets/question.png" style="width: 20px;height: 20px;margin-left: 5px;cursor: pointer;" @click="openMsg(4)">
									</div>
									<el-input type="text" placeholder="请输入默认配置" size="small" v-model="software_info.config"
										style="width: 300px;"></el-input>
								</el-form-item>
								<el-form-item label="详细说明">
									<div slot="label" style="display: flex;align-items: center;">
										<span>请输入详细说明</span>
										<img src="../../assets/question.png" style="width: 20px;height: 20px;margin-left: 5px;cursor: pointer;" @click="openMsg(6)">
									</div>
									<el-input
									  type="textarea"
									  :autosize="{ minRows: 4, maxRows: 10}"
									  placeholder="请输入详细说明"
									  v-model="software_info.descriptions"
									  style="width: 300px;">
									</el-input>
								</el-form-item>
								<el-form-item label="是否展示在软件展示列表">
									<div slot="label" style="display: flex;align-items: center;">
										<span>是否展示在软件展示列表</span>
										<img src="../../assets/question.png" style="width: 20px;height: 20px;margin-left: 5px;cursor: pointer;" @click="openMsg(7)">
									</div>
									<el-radio-group v-model="software_info.is_display_page">
										<el-radio :label="1">展示</el-radio>
										<el-radio :label="0">不展示</el-radio>
									</el-radio-group>
								</el-form-item>
								<el-form-item label="是否展示在软件展示列表">
									<div slot="label" style="display: flex;align-items: center;">
										<span>是否顶号登录</span>
										<img src="../../assets/question.png" style="width: 20px;height: 20px;margin-left: 5px;cursor: pointer;" @click="openMsg(8)">
									</div>
									<el-radio-group v-model="software_info.login_method">
										<el-radio :label="0">顶号登录</el-radio>
										<el-radio :label="1">不顶号登录</el-radio>
									</el-radio-group>
								</el-form-item>
								<el-form-item label="微信扫码试用生成类型">
									<div slot="label" style="display: flex;align-items: center;">
										<span>微信扫码试用生成类型</span>
										<img src="../../assets/question.png" style="width: 20px;height: 20px;margin-left: 5px;cursor: pointer;" @click="openMsg(9)">
									</div>
									<el-radio-group v-model="software_info.try_create_type">
										<el-radio :label="0">卡密</el-radio>
										<el-radio :label="1">账号</el-radio>
									</el-radio-group>
								</el-form-item>
								<el-form-item label="是否出售一卡多端登录">
									<div slot="label" style="display: flex;align-items: center;">
										<span>是否出售一卡多端登录</span>
										<img src="../../assets/question.png" style="width: 20px;height: 20px;margin-left: 5px;cursor: pointer;" @click="openMsg(10)">
									</div>
									<el-radio-group v-model="software_info.is_sell_onlinenum">
										<el-radio :label="1">是</el-radio>
										<el-radio :label="0">否</el-radio>
									</el-radio-group>
								</el-form-item>
								<el-form-item label="用户页展示项">
									<div slot="label" style="display: flex;align-items: center;">
										<span>用户页展示项</span>
										<img src="../../assets/question.png" style="width: 20px;height: 20px;margin-left: 5px;cursor: pointer;" @click="openMsg(11)">
									</div>
									<el-checkbox-group v-model="software_info.user_regcharge_show_type">
										<el-checkbox label="account_regist" value="account_regist">账号注册</el-checkbox>
										<el-checkbox label="account_charge" value="account_charge">账号充值</el-checkbox>
										<el-checkbox label="card_charge" value="card_charge">卡密充值</el-checkbox>
									</el-checkbox-group>
								</el-form-item>
						</div>
					</div>
					<div style="height: 20px;" v-if="!showSuper"></div>
					<div style="padding:0px 20px 20px 20px;display: flex;align-items: center;justify-content: flex-end;background-color: rgb(66, 75, 79);border-bottom-left-radius: 5px;border-bottom-right-radius: 5px;">
							<el-button type="primary" size="small" @click="submitForm('softwareForm')">修改</el-button>
					</div>
				</el-form>
				
				<div class="centext-box" style="margin-top: 20px;">
					<div class="header">
						减免
					</div>
					<div style="padding: 10px;">
						<div class="t-header">
							<div class="t-item">
								满足金额
							</div>
							<div class="t-item">
								减免金额
							</div>
							<div class="t-item">
								是否叠加
							</div>
							<div class="t-item">
								操作
							</div>
						</div>
						<div class="t-body" v-for="(item,index) in software_info.full_minus" :key="index">
							<div class="t-item">
								<el-input type="number" placeholder="请输入" size="small"
									v-model="item.full_amount" style="width: 80px;" :step="0.01"></el-input>
							</div>
							<div class="t-item">
								<el-input type="number" placeholder="请输入" size="small"
									v-model="item.minus_amount" style="width: 80px;" :step="0.01"></el-input>
							</div>
							<div class="t-item">
								<el-switch v-model="item.could_repeat" size="small"  active-value="1" inactive-value="0">
								</el-switch>
							</div>
							<div class="t-item">
								 <el-link icon="el-icon-edit" type="primary" style="margin-right: 20px;" @click="full_minus_save(item)">保存</el-link>
								 <el-link icon="el-icon-delete" type="danger" @click="full_minus_delete(item,index)">删除</el-link>
							</div>
						</div>
						<div style="padding: 10px;display: flex;justify-content: flex-end;">
							<el-button type="success" size="small" @click="addFullMinus()" style="width: 100%;">+添加一项</el-button>
						</div>
					</div>
				</div>
			</el-col>
		</el-row>
		<el-dialog title="提示" :visible.sync="dialogCodeVisible" width="340px">
			<div style="padding: 0px 10px 0px 10px;font-size: 14px;text-align: center;">
				{{msg}}
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import Picker from '../../components/select/Picker.vue'
	export default {
		components:{
			Picker
		},
		data() {
			return {
				id: null,
				dialogCodeVisible:false,
				msg:'',
				showSuper:false,
				msg_list:[
					'心跳的概念请查看帮助',
					'除了平台定义的卡密，开发者还可以自己定义一种卡密类型并指定时间',
					'自动售卡时，每个微信可获取x次试用卡来试用软件。',
					'填0则表示每个微信终身只能试用一次。3600表示每个微信每个小时可以试用一次，用户试用需要看广告，用户看的广告越多，平台给您奖励的api时长越多。详情请查看帮助.',
					'这里填写的默认配置，在自动售卡时，会自动填写到生成的卡密配置里',
					'可以通过接口读取，显示在您的软件上，没有用到请忽略此项',
					'展示在软件出售界面，没有用到自动售卡功能请忽略。',
					'软件展示列表是一个网页，上面可以展示您的所有软件，如果不想在这个列表展示本软件，关闭此项即可，如果没有启用这个网页，则忽略此项',
					'顶号登录，意思是同一个账号或卡密，在登录一次后，第二次登录会把第一次登录顶下线，正常情况下请选择顶号登录。不顶号登录：意思是账号在登录一次后，如果不退出，再次登录时会登录失败，必须退出后才能再次登录。这个适用于登录和退出不频繁的软件，退出有两种方式。软件停止时调用接口退出，或者在软件的用户中心网页上点击退出按钮。',
					'取决于您的软件是卡密登录还是账号密码登录，选择对应的类型即可',
					'如果开启这个开关，那么在自动售卡时，用户就可以自行选择购买的每个卡密可以同时登录几个端，卡密多端登录相关信息请查看帮助',
					'用户充值注册页面，有多项功能，请选择您想要展示的功能，如果没有启用用户充值注册页面，请忽略此项。',
					'关闭后，软件即不可登陆心跳，前台用户在心跳时会全部停止，并且无法登录',
				],
				base_info_list: [],
				software_info: {
					path: "",
					one: "",
					version: "",
					onlinenum: "",
					config: "",
					card_length: 0,
					heart_beat_time: 0,
					defind_card_time: "",
					cardname: "",
					description: "",
					descriptions: "",
					test_card_time: 0,
					try_use_freeze: "",
					is_display_page: 0,
					login_method: 0,
					try_create_type: 1,
					is_sell_onlinenum: 1,
					user_regcharge_show_type: [],
					switch: 1,
					free_card_num:0,
					free_card_need_adtimes:0,
					free_card_timelong:0,
					free_card_show_on_agent_page:0
				},
				price:[],
				salesquence:[],
				software_rules: {
					path: [{
						required: true,
						message: '请填写下载地址',
						trigger: 'blur'
					}],
					one: [{
						required: true,
						message: '请填写中文名',
						trigger: 'blur'
					}],
					version: [{
						required: true,
						message: '请输入版本号',
						trigger: 'blur'
					}],
					
					onlinenum: [{
						required: true,
						message: '请输入允许多端数量',
						trigger: 'blur'
					}],
					card_length: [{
						required: true,
						message: '请输入卡密长度',
						trigger: 'blur'
					}],
					heart_beat_time: [{
						required: true,
						message: '请输入心跳时间',
						trigger: 'blur'
					}],
					defind_card_time: [{
						required: true,
						message: '请输入自定义时间',
						trigger: 'blur'
					}],
					cardname: [{
						required: true,
						message: '请输入对外展示名称',
						trigger: 'blur'
					}],
					test_card_time: [{
						required: true,
						message: '请输入试用时间',
						trigger: 'blur'
					}],
					try_use_freeze: [{
						required: true,
						message: '请输入每个微信试用时间间隔',
						trigger: 'blur'
					}],
					config: [{
						required: true,
						message: '请输入默认配置',
						trigger: 'blur'
					}],
					description: [{
						required: true,
						message: '请输入软件公告',
						trigger: 'blur'
					}],
					free_card_num:[{
						required: true,
						message: '请输入每天下发的免费卡数量',
						trigger: 'blur'
					}],
					free_card_need_adtimes:[{
						required: true,
						message: '请输入看几次广告可以获取免费卡',
						trigger: 'blur'
					}],
					free_card_timelong:[{
						required: true,
						message: '请输入免费卡的可用时长',
						trigger: 'change'
					}],
				},
			}
		},
		props: {
			software_id: [String, Number]
		},
		created() {
			console.log(this.software_id)
			this.getDetail()
		},
		methods: {
			confrimDate(e,key){
				console.log(e)
				this.$set(this.software_info,key,e)
			},
			openMsg(index){
				this.msg = this.msg_list[index]
				setTimeout(()=>{
					this.dialogCodeVisible = true
				},100)
			},
			full_minus_save(item){
				console.log(item)
				if(parseFloat(item.full_amount) < parseFloat(item.minus_amount)){
					return this.$message.error('满足金额必须大于减免金额')
				}
				let data = {
					...item,
				}
				this.$H.post('verify_center/v1_0_1.Software/EditFullMinus',data).then(res => {
					if(res.data) return this.$message.success('处理成功')
				});
			},
			addFullMinus(){
				this.$H.post('verify_center/v1_0_1.Software/CreateFullMinus',{
					software_id:this.software_id,
				},true).then(res => {
					if(!res.data) return true;
					this.software_info.full_minus = this.software_info.full_minus.concat(res.data.item);
				});
			},
			full_minus_delete(item,index){
				this.$confirm('是否删除添加项?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$H.post('/verify_center/v1_0_1.Software/DeleteFullMinus', {
						id:item.id
					}).then(res => {
						if(!res.data) return true;
						this.software_info.full_minus.splice(index,1);
					});
							
				}).catch(() => {
							
				});
			},
			switchChange(e,v){
				console.log(v)
				if(!e){
					let index = this.salesquence.findIndex(item=>item==v)
					if(index>-1){
						this.salesquence.splice(index,1)
					}
				}else{
					this.salesquence.push(parseInt(v))
				}
				console.log(this.salesquence)
			},
			submit(type){
				let submit_data = {}
				if(type==='card_sell'){
					submit_data = {
						price:JSON.stringify(this.price),
						salesquence:JSON.stringify(this.salesquence)
					}
				}
				this.$H.post('/verify_center/v1_0_1.Software/Edit', {
					...submit_data,
					id: this.software_id
				}).then(res => {
					if(!res.data) return;
					this.$message.success('处理成功')
					this.getDetail()
				});
			},
			submitForm(type) {
				console.log(this.software_info.user_regcharge_show_type)
				
				let submit_data = {}
				this.$refs['softwareForm'].validate((valid) => {
					switch(type){
						case 'free_card':
						
							 submit_data = {
								free_card_num:this.software_info.free_card_num,
								free_card_need_adtimes:this.software_info.free_card_need_adtimes,
								free_card_timelong:this.software_info.free_card_timelong,
								free_card_show_on_agent_page:this.software_info.free_card_show_on_agent_page
							}
						
							break;
							
						case 'card_sell':
						
							 submit_data = {
								price:JSON.stringify(this.price),
								salesquence:this.software_info.salesquence
							}
						
							break;
							
						case 'softwareForm':
						
							 submit_data = {
								path:this.software_info.path,
								one:this.software_info.one,
								version:this.software_info.version,
								onlinenum:this.software_info.onlinenum,
								config:this.software_info.config,
								card_length:this.software_info.card_length,
								heart_beat_time:this.software_info.heart_beat_time,
								defind_card_time:this.software_info.defind_card_time,
								cardname:this.software_info.cardname,
								description:this.software_info.description,
								descriptions:this.software_info.descriptions,
								test_card_time:this.software_info.test_card_time,
								try_use_freeze:this.software_info.try_use_freeze,
								is_display_page:this.software_info.is_display_page,
								login_method:this.software_info.login_method,
								try_create_type:this.software_info.try_create_type,
								is_sell_onlinenum:this.software_info.is_sell_onlinenum,
								user_regcharge_show_type:JSON.stringify(this.software_info.user_regcharge_show_type),
								switch:this.software_info.switch,
							}
							break;
							
						default:return false;
					}
					if (valid) {
						
						this.$H.post('/verify_center/v1_0_1.Software/Edit', {
							...submit_data,
							id: this.software_id
						}).then(res => {
							if(!res.data) return;
							this.$message.success('修改成功')
							this.getDetail()
						});
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			copy(url) {
				this.$copyText(url).then((e) => {
					this.$message.success('复制成功')
					console.log(e)
				}, (e) => {
					console.log(e)
				})
			},

			getDetail() {
				this.$H.post('verify_center/v1_0_2.Software/Info', {
					id: this.software_id
				}).then(res => {
					console.log(res)
					res.data.user_regcharge_show_type = res.data.user_regcharge_show_type === "" ? [] : JSON.parse(
						res.data.user_regcharge_show_type)
					this.software_info = res.data
					this.software_info.full_minus = this.software_info.full_minus.map(item=>{
						item.minus_amount = (item.minus_amount/100).toFixed(2)
						item.full_amount =  (item.full_amount/100).toFixed(2)
						return item
					})
					console.log(this.software_info)
					this.price = JSON.parse(res.data.price)
					this.salesquence = JSON.parse(res.data.salesquence);
					this.base_info_list = [{
							title: '软件id',
							show_value: res.data.id,
							copy_value: res.data.id
						},
						{
							title: '软件名',
							show_value: res.data.name,
							copy_value: res.data.name
						},
						{
							title: '软件备注',
							show_value: res.data.one,
							copy_value: res.data.one
						},
						{
							title: '帐号注册充值地址',
							show_value: '',
							copy_value: res.data.ucenter_domain + 'reg_charge.html?sell_code=' + res.data
								.sell_code
						},
						{
							title: '用户中心地址',
							show_value: '',
							copy_value: res.data.ucenter_domain + 'ucenter.html?sell_code=' + res.data
								.sell_code
						},
						{
							title: '卡密出售地址',
							show_value: '',
							copy_value: res.data.ucenter_domain + 'buy_card.html?sell_code=' + res.data
								.sell_code
						},
						{
							title: '下载地址',
							show_value: '',
							copy_value: res.data.path
						},
						{
							title: '在线人数',
							show_value: res.data.online_member,
							copy_value: false
						},
					];
				});
			},
		}
	}
</script>

<style scoped>
	.centext-box {
		border-radius: 5px;
		background-color: rgb(66, 75, 79);
		color: #fff
	}

	.centext-box .header {
		font-size: 14px;

	}

	.form>>>.el-form-item__label {
		color: #fff !important;
	}

	.form>>>.el-input__inner {
		background-color: rgb(66, 75, 79);
		border: 1px solid #ccc !important;
		color: #fff;
	}
	.t-item >>>.el-input__inner {
		background-color: rgb(66, 75, 79);
		border: 1px solid #ccc !important;
		color: #fff;
	}
	.form>>>.el-input.is-disabled .el-input__inner {
		background-color: rgb(66, 75, 79);
		border: 1px solid #ccc !important;
		color: #fff;
	}

	.form>>>.el-radio__label {
		color: #fff;
	}

	.form>>>.el-textarea__inner {
		background-color: rgb(66, 75, 79);
		border: 1px solid #ccc !important;
		color: #fff;
	}

	.form>>>.el-checkbox__label {
		color: #fff;
	}

	.t-header {
		padding: 13px;
		border-bottom: 1px solid #909090;
		font-size: 14px;
		font-weight: 700;
		display: flex;
	}

	.t-body {
		padding:8px 13px;
		border-bottom: 1px solid #909090;
		font-size: 14px;
		font-weight: normal;
		display: flex;
	}

	.t-item {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: center;
	}
</style>